import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner, Dropdown } from 'yankees-react-utils';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import GameLogGame from './GameLogGame';
import { useOktaQuery, Game } from '../data';
import useConfig from '../utils/useConfig';

const StyledHeader = styled.h4`
    @media (min-width: 992px) {
        position: sticky;
        top: 0;
    }
`;

const queryGames = async (accessToken, playerId, yearId) => {
    const resp = await Game.byplayerstats(accessToken, { playerId, yearId });
    return resp.games.sort((a, b) => (dayjs(a.gamedate).isBefore(b.gamedate) ? 1 : -1));
};

const GameLogs = ({ playerId, isPitcher, isCatcher, header, gameWrapper, getStatLines }) => {
    const { t: translate } = useTranslation();
    const { CurrentYear } = useConfig();
    const [year, setYear] = useState({ name: CurrentYear, value: CurrentYear });
    const { data: games, status, refetch } = useOktaQuery(
        ['gamesbyplayerstats', { playerId, includePrevious: true, yearId: year.value }],
        (accessToken) => queryGames(accessToken, playerId, year.value),
    );
    const yearOptions = [CurrentYear, CurrentYear - 1, CurrentYear - 2, CurrentYear - 3, CurrentYear - 4,
        CurrentYear - 5, CurrentYear - 6, CurrentYear - 7, CurrentYear - 8, CurrentYear - 9, CurrentYear - 10].map((y) => ({ name: y, value: y }));

    useEffect(() => {
        refetch();
    }, [year, refetch]);
    if (status === 'loading') {
        return (
            <div className="d-flex py-5 justify-content-center">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-1">
                {header || (
                    <StyledHeader className="mb-0">
                        {translate('home.game-logs')}
                    </StyledHeader>
                )}

                <Dropdown options={yearOptions} value={year} onSelect={setYear} />
            </div>
            {games?.length
                ? (
                    <div className="border rounded overflow-hidden">
                        {games.map((game) => (
                            <GameLogGame
                                game={game}
                                isPitcher={isPitcher}
                                isCatcher={isCatcher}
                                playerId={playerId}
                                key={game.gameid}
                                wrapper={gameWrapper}
                                getStatLines={getStatLines}
                            />
                        ))}
                    </div>
                )
                : <div className="d-flex justify-content-center py-2">{translate('home.no-games')}</div>}
        </>
    );
};

GameLogs.propTypes = {
    playerId: PropTypes.number.isRequired,
    isPitcher: PropTypes.bool,
    isCatcher: PropTypes.bool,
    header: PropTypes.element,
    gameWrapper: PropTypes.func,
    getStatLines: PropTypes.func,
};

GameLogs.defaultProps = {
    isPitcher: false,
    isCatcher: false,
    header: undefined,
    gameWrapper: undefined,
    getStatLines: undefined,
};

export default GameLogs;
